import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { useOauthUserIntegrationsQuery } from 'api';
import { useNotify } from 'hooks';

import Integration from './Integration';

const OAuthAppsIndex: FC = () => {
  const notify = useNotify();
  const { t } = useTranslation();

  const { data } = useOauthUserIntegrationsQuery(
    {},
    {
      onError: notify.queryError,
    }
  );

  return (
    <Grid container>
      <Grid xs={3}>
        <Typography variant="h6">{t('components:oauthAccess')}</Typography>
      </Grid>
      <Grid xs>
        {!data?.oauthUserIntegrations.length && (
          <Typography>
            <em>{t('components:noOauthAccessIntegrations')}</em>
          </Typography>
        )}
        {data?.oauthUserIntegrations.map(existingIntegration => (
          <Fragment key={existingIntegration.oauth_client_id}>
            <Integration integration={existingIntegration} />
            <Box marginTop={3} marginBottom={4}>
              <Divider />
            </Box>
          </Fragment>
        ))}
      </Grid>
    </Grid>
  );
};

export default OAuthAppsIndex;
